<script lang="ts" setup generic="T extends IncidentAttributeId">
import { ref } from 'vue'

import { Coordinates, hasIncidentPosition } from '@collector/shared-ui-domain'
import { IncidentAttributeId } from '@collector/sportsapi-client-legacy'
import { Incident } from '@collector/sportsapi-types'
import Button from '@mobile/components/Button/Button.vue'
import Tabs from '@mobile/components/Tabs/Tabs.vue'
import IncidentBasicInfo from '@mobile/views/Relation/DetailsPanel/Modals/IncidentDetailsModal/IncidentBasicInfo.vue'
import Modal from '@mobile/views/Relation/DetailsPanel/Modals/Modal.vue'
import ModalButtons from '@mobile/views/Relation/DetailsPanel/Modals/ModalButtons.vue'
import { ProbableLinkedIncident } from '@mobile/views/Relation/Shared/RelationDependencies/types'

import ExpectedGoalsCoordinatesPitch from './ExpectedGoalsCoordinatesPitch.vue'

type Props = {
  linkedIncident: ProbableLinkedIncident
}

const props = defineProps<Props>()

// data
const tabs = ['Coordinates', 'Details']

// emits
interface Emits {
  close: []
  save: [{ coordinates: Coordinates | null }]
}
defineEmits<Emits>()

// state
const currentTab = ref(tabs[0])
const coordinates = ref<Coordinates | null>(
  hasIncidentPosition(props.linkedIncident.incident as unknown as Incident)
    ? {
        x: props.linkedIncident.incident.x_pos!,
        y: props.linkedIncident.incident.y_pos!,
      }
    : null,
)
</script>

<template>
  <Modal id="incidentDetailsModal">
    <IncidentBasicInfo :linkedIncident />

    <Tabs
      v-model:currentTab="currentTab"
      :tabs
    ></Tabs>

    <template v-if="currentTab === 'Coordinates'">
      <div class="pt-4">
        <ExpectedGoalsCoordinatesPitch
          v-model:coordinates="coordinates"
          :linkedIncident
        />
      </div>

      <div class="pt-4">
        <slot name="coordinatesTabContent" />
      </div>
    </template>

    <template v-if="currentTab === 'Details'">
      <div class="pt-4">
        <slot name="detailsTabContent" />
      </div>
    </template>
    <ModalButtons>
      <Button
        color="red"
        :size="'lg'"
        @click="$emit('close')"
      >
        Close
      </Button>
      <Button
        class="px-8"
        color="green"
        :size="'lg'"
        @click="$emit('save', { coordinates })"
      >
        Save
      </Button>
    </ModalButtons>
  </Modal>
</template>
